// 'N일' 설정값: 1 이상의 정수만 허용 (빈 값·0·소수·음수는 저장 불가)
export const isValidWholeDays = (value) => {
	if (value === null || value === undefined || String(value).trim() === '') return false;
	const n = Number(value);
	return Number.isInteger(n) && n >= 1;
};

export const isValidNewInstalledDays = isValidWholeDays;
